<template>
  <div class="recruitment-view">
    <div class="recruitment-title">人才体系</div>
    <div class="view-img">
      <imgContainer :src="bannerInfo.img" />
    </div>
  </div>
  <div class="recruitment-special"></div>
</template>

<script setup>
import { ref} from "vue";
import {getBannerList} from "@/api/apiHome";
import imgContainer from '@/components/imgContainer/index.vue'

const bannerInfo = ref({})
const queryTopBannerList = async () => {
  const {code, data} = await getBannerList(9)
  if (code === 200) {
    bannerInfo.value = data && data.length > 0 ? data[0] : {}
  }
}
queryTopBannerList()
</script>

<style lang="scss" scoped>
.recruitment-view {
  width: 100%;
  height: 689px;
  background: #fff;
  padding-top: 50px;
  box-sizing: border-box;
  position: absolute;
  top:-80px;
  left: 0;
}
.recruitment-special{
  width: 100%;
  height: 609px;
}

.recruitment-title {
  font-weight: bold;
  font-size: 28px;
  color: #242424;
  position: relative;
  text-align: center;
}

.recruitment-title::after {
  content: "";
  position: absolute;
  bottom: -16px;
  left: 50%;
  transform: translateX(-50%);
  width: 52px;
  height: 4px;
  background: #0048A9;
  border-radius: 2px;
  transition: all 0.3s ease;
}

.view-img {
  margin-top: 50px;
  width: 100%;
  height: 548px;
}
</style>
